export const ESRI_TILES = "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}";
export const ESRI_ATTR = "Tiles &copy; Esri &mdash; Esri, Maxar, Earthstar Geographics";
export const DEFAULT_ALIGN = { lat: null, lon: null, rotation: 0, scale: 1, flip: false };
const M = 111320;
const rad = (d) => (d * Math.PI) / 180;

export const hasGeo = (track) => track && track.lat != null && track.lon != null;

export const hasAbsGps = (lap) => lap?.lat?.length > 0 && lap?.lon?.length > 0;

export function projectTrace(lap, track, align) {
  if (hasAbsGps(lap)) return lap.lat.map((la, i) => [la, lap.lon[i]]);
  const { x, y } = lap;
  const cx = (Math.min(...x) + Math.max(...x)) / 2;
  const cy = (Math.min(...y) + Math.max(...y)) / 2;
  const lat0 = align.lat ?? track.lat;
  const lon0 = align.lon ?? track.lon;
  const c = Math.cos(rad(align.rotation)), s = Math.sin(rad(align.rotation));
  const f = align.flip ? -1 : 1, k = align.scale, kLon = M * Math.cos(rad(lat0));
  return x.map((xi, i) => {
    const dx = (xi - cx) * f, dy = y[i] - cy;
    return [lat0 + (k * (dx * s + dy * c)) / M, lon0 + (k * (dx * c - dy * s)) / kLon];
  });
}

export function nudge(align, track, dEast, dNorth) {
  const lat = align.lat ?? track.lat;
  const lon = align.lon ?? track.lon;
  return { ...align, lat: lat + dNorth / M, lon: lon + dEast / (M * Math.cos(rad(lat))) };
}

export function gColor(v, max) {
  const f = Math.max(-1, Math.min(1, v / (max || 1)));
  return `hsl(${f < 0 ? 210 : 5}, 95%, ${Math.round(92 - 42 * Math.abs(f))}%)`;
}

export const isGpsChannel = (c) => /^lat(itude)?$|^(lon|lng|long|longitude)$/i.test(c);
